import { withStyles, WithStyles, StyleRulesCallback, Theme } from '@material-ui/core';
import * as React from 'react';
import { pure } from 'recompose';
import HuesgesForm from '../container/HuesgesForm';
import { Card, CardHeader } from '@material-ui/core';
import { AssistantData, HuesgesData } from '../../../model/inspectionData';
import { BpM } from '../../../shared/brakepoints';
import Translator from '../../../components/Translator';
import kefirConfig from 'recompose/kefirObservableConfig';

type CssClasses = 'cardContent' | 'container';
const styles: StyleRulesCallback<CssClasses> = (theme: Theme) => ({
  container: {
    width: '100%',
    [BpM()]: {
      width: '800px',
      marginLeft: 'auto',
      marginRight: 'auto',
    },
  },
  cardContent: {
    paddingLeft: theme.spacing.unit * 4,
    paddingRight: theme.spacing.unit * 4,
    paddingBottom: theme.spacing.unit * 4,
    fontSize: '17px',
  },
});

interface Props {
  inspectionId: string;
  assistantData: AssistantData | null;
  onSubmitHandler: (values: HuesgesData) => Promise<any>;
}

const emptyHuesgesData: Pick<
  HuesgesData,
  'vehicleManufacturer' | 'vehicleModel' | 'mail' | 'phoneNumber' | 'zipCode'
> = {
  // company: '',
  // vehicleVin: '',
  // vehicleLicensePlate: '',
  vehicleManufacturer: '',
  vehicleModel: '',
  // salutation: '',
  // firstName: '',
  // lastName: '',
  mail: '',
  phoneNumber: '',
  // street: '',
  // houseNumber: '',
  zipCode: '',
  // city: '',
  // alternativeName: '',
  // alternativeStreet: '',
  // alternativeHouseNumber: '',
  // alternativeZipCode: '',
  // alternativeCity: '',
};

function memoize() {
  let previous: AssistantData | null = null;
  let output: typeof emptyHuesgesData = {
    ...emptyHuesgesData,
  };

  return (input: AssistantData | null) => {
    if (input !== previous) {
      previous = input;
      if (input == null) {
        output = {
          ...emptyHuesgesData,
        };
      } else {
        output = {
          ...emptyHuesgesData,
          vehicleManufacturer: input.vehicleManufacturer,
          vehicleModel: input.vehicleModel,
          mail: input.mail,
          phoneNumber: input.phoneNumber,
          zipCode: input.zipCode,
        };
      }
    }

    return output;
  };
}

const latestAssistantData = memoize();

const HuesgesInspection = ({
  classes,
  inspectionId,
  assistantData,
  onSubmitHandler,
}: Props & WithStyles<CssClasses>) => (
  <Translator>
    {translate => {
      return (
        <Card className={classes.container}>
          <CardHeader title={translate('inspectionPageTitle')} />
          <div className={classes.cardContent}>
            <div dangerouslySetInnerHTML={{ __html: translate('inspectionWelcomeTextHuesges') }} />

            <HuesgesForm
              initialValues={latestAssistantData(assistantData)}
              initalData={assistantData}
              inspectionId={inspectionId}
              onSubmitHandler={onSubmitHandler}
            />
          </div>
        </Card>
      );
    }}
  </Translator>
);

export default pure(withStyles(styles)(HuesgesInspection));



// WEBPACK FOOTER //
// ./src/routes/inspection/components/HuesgesInspection.tsx